module.exports = __webpack_public_path__ + "img/support_icon.59b64953.svg";